module.exports = __webpack_public_path__ + "static/outcomes-f7b7a42b51c98345ec0be91830759c43.png";